import icons from '@/mixins/icons.js'
export default {
  name: 'tab',
  props: {
    tabs: Array,
    showIconsToo: {
      type: Boolean,
      default: false
    },
    showOnlyIcons: {
      type: Boolean,
      default: false
    },
    isKlasSelected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      allTabs: []
    }
  },
  mixins: [icons],
  created () {
    this.allTabs = JSON.parse(JSON.stringify(this.tabs))
    this.initializeSelectedTabProperty()
  },
  methods: {
    getTab (tabNameAsString) {
      return this.allTabs.filter(function (tab) {
        return tab.name === tabNameAsString
      })[0]
    },
    initializeSelectedTabProperty () {
      this.allTabs.map(function (t, idx) {
        t._selectedTab = false
        t._id = idx
      })
      this.allTabs[0]._selectedTab = true
    },
    tabClicked (item) {
      item = typeof item !== 'string' ? item : this.getTab(item)
      let allTabs = JSON.parse(JSON.stringify(this.allTabs))
      for (let i = 0; i < allTabs.length; i++) {
        if (item._id === allTabs[i]._id) {
          allTabs[i]._selectedTab = true
        } else {
          allTabs[i]._selectedTab = false
        }
      }
      this.allTabs = allTabs // in order to update styles (vue_known_bug)
      this.$emit('tab-selected', item) // selectedTab function in parent is triggered
    }
  }
}
